// Copyright 2025, University of Maryland, All Rights Reserved
export function ActionsPlugin({ children }: { children: React.ReactNode }) {
  return children
}
